module.exports = __webpack_public_path__ + "img/zz_mockuphone3.c4e1f3de.png";